import SweetScroll from 'sweet-scroll';

export default new SweetScroll({
  duration: 800,
});
